import Vue from 'vue';
import CookieControl from "\u002Fvar\u002Fwww\u002Filajak-frontend\u002Fnode_modules\u002Fnuxt-cookie-control\u002Fcomponents\u002FCookieControl.vue";
import CookieIframe from "\u002Fvar\u002Fwww\u002Filajak-frontend\u002Fnode_modules\u002Fnuxt-cookie-control\u002Fcomponents\u002FCookieIframe.vue";
export default(context, inject) =>{
  let cookies = {
    modal: false,
    consent: false,
    enabled: [],
    enabledList: [],
    optional: []
  }

  Object.assign(cookies, {"necessary":[{"name":{"en":"Necessary Cookies","fr":"Cookies nécessaires","ar":"الكوكيز الضرورية"},"description":{"en":"These cookies are essential for the website to function properly.","fr":"Ces cookies sont essentiels au bon fonctionnement du site.","ar":"هذه الكوكيز ضرورية لكي يعمل الموقع بشكل صحيح."},"cookies":[]}],"optional":[{"name":{"en":"Analytics Cookies","fr":"Cookies d'analyse","ar":"كوكيز التحليل"},"description":{"en":"These cookies help us understand how our website is being used.","fr":"Ces cookies nous aident à comprendre comment notre site web est utilisé.","ar":"تساعدنا هذه الكوكيز على فهم كيفية استخدام موقعنا."},"accepted":() => {
        // Initialize Google Analytics
        window.dataLayer = window.dataLayer || [];

        function gtag() {
          dataLayer.push(arguments);
        }

        gtag('js', new Date());
        gtag('config', 'UA-141189011-1');
      },"declined":() => {
        // Remove Analytics cookies
        const cookieNames = ['_ga', '_ga_W6FB74N', '_gid'];
        cookieNames.forEach((name) => {
          window.$nuxt.$cookies.remove(name);
        });

        // Remove Google Analytics scripts if possible
        const gaScript = document.querySelector(`script[src*="www.googletagmanager.com/gtag/js"]`);
        if (gaScript) {
          gaScript.parentNode.removeChild(gaScript);
        }

        // Clear any analytics-related data from dataLayer
        if (window.dataLayer) {
          window.dataLayer = window.dataLayer.filter((event) => {
            return !event[1] || event[1] && !event[1].includes('UA-141189011-1');
          });
        }
      }},{"name":{"en":"Marketing cookies","fr":"Cookies de marketing","ar":"كوكيز التسويق"},"description":{"en":"Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.","fr":"Les cookies de marketing sont utilisés pour suivre les visiteurs à travers les sites web. L'intention est d'afficher des publicités pertinentes et engageantes pour l'utilisateur individuel et donc plus précieuses pour les éditeurs et les annonceurs tiers.","ar":"تستخدم كوكيز التسويق لتتبع الزوار عبر المواقع الإلكترونية. النية هي عرض إعلانات ذات صلة وجذابة للمستخدم الفرد، وبالتالي تكون أكثر قيمة للناشرين والمعلنين من الأطراف الثالثة."},"accepted":() => {
        // Google Analytics (if not initialized in Analytics Cookies)
        window.dataLayer = window.dataLayer || [];

        function gtag() {
          dataLayer.push(arguments);
        }

        gtag('js', new Date());
        gtag('config', 'UA-141189011-1');

        // Facebook Pixel
        !function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '428177364628231');
        fbq('track', 'PageView');

        // Hotjar
        (function (h, o, t, j, a, r) {
          h.hj = h.hj || function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
          h._hjSettings = { hjid: 1375486, hjsv: 6 };
          a = o.getElementsByTagName('head')[0];
          r = o.createElement('script');
          r.async = 1;
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
          a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
      },"declined":() => {
        // Remove Marketing cookies
        const cookieNames = ['_fbp', '_gcl_au', '_gat_gtag_UA_141189011-1', '_gid', '_hjIncludedInSample'];
        cookieNames.forEach((name) => {
          window.$nuxt.$cookies.remove(name);
        });

        // Remove third-party marketing scripts if possible
        const scriptsToRemove = [
        'https://www.googletagmanager.com/gtag/js',
        'https://connect.facebook.net/en_US/fbevents.js',
        'https://static.hotjar.com/c/hotjar-'];

        scriptsToRemove.forEach((src) => {
          const script = document.querySelector(`script[src^="${src}"]`);
          if (script) {
            script.parentNode.removeChild(script);
          }
        });

        // Remove Facebook Pixel tracking if applicable
        if (window.fbq) {
          fbq('consent', 'revoke');
        }

        // Clear any marketing-related data from dataLayer
        if (window.dataLayer) {
          window.dataLayer = window.dataLayer.filter((event) => {
            return !event[1] || event[1] && !event[1].includes('UA-141189011-1');
          });
        }
        // Clear Hotjar session if possible
        if (window.hj) {
          window.hj('reset');
        }
      }}],"text":{"locale":{"ar":{"barTitle":"الكوكيز","barDescription":"نحن نستخدم الكوكيز الخاصة بنا والكوكيز الخاصة بالأطراف الثالثة حتى نتمكن من عرض هذا الموقع وفهم كيفية استخدامك له بشكل أفضل، بهدف تحسين الخدمات التي نقدمها. إذا واصلت التصفح، فإننا نعتبر أنك قد قبلت الكوكيز.","acceptAll":"قبول الكل","declineAll":"حذف الكل","acceptNecessary":"قبول الضروريات","manageCookies":"إدارة الكوكيز","unsaved":"لديك إعدادات غير محفوظة","close":"X","save":"حفظ","necessary":"الكوكيز الضرورية","optional":"الكوكيز الاختيارية","functional":"الكوكيز الوظيفية","blockedIframe":"لرؤية هذا، يرجى تمكين الكوكيز الوظيفية","here":"هنا"},"fr":{"barTitle":"Cookies","barDescription":"Nous utilisons nos propres cookies et des cookies tiers pour vous présenter ce site web et mieux comprendre comment vous l'utilisez, dans le but d'améliorer les services que nous offrons. Si vous continuez à naviguer, nous considérons que vous avez accepté les cookies.","acceptAll":"Accepter tout","declineAll":"Supprimer tout","manageCookies":"Gérer les cookies","unsaved":"Vous avez des paramètres non sauvegardés","close":"X","save":"Sauvegarder","necessary":"Cookies nécessaires","optional":"Cookies optionnels","functional":"Cookies fonctionnels","blockedIframe":"Pour voir cela, veuillez activer les cookies fonctionnels","here":"ici"},"en":{"close":"X"}}},"css":true,"cssPolyfill":true,"controlButton":true,"acceptNecessary":false,"barPosition":"bottom-left","iframe":"\u002Fvar\u002Fwww\u002Filajak-frontend\u002Fnode_modules\u002Fnuxt-cookie-control\u002Fcomponents\u002FCookieIframe.vue","component":"\u002Fvar\u002Fwww\u002Filajak-frontend\u002Fnode_modules\u002Fnuxt-cookie-control\u002Fcomponents\u002FCookieControl.vue","colors":{"barBackground":"#fff","barButtonColor":"#fff","barButtonHoverColor":"#01BAC6","barButtonBackground":"#01BAC6","barTextColor":"#000","modalButtonColor":"#fff","modalButtonHoverColor":"#fff","modalTextColor":"#000","modalBackground":"#fff","checkboxInactiveBackground":"#eee","checkboxActiveBackground":"#01BAC6","modalButtonBackground":"#01BAC6"},"locales":["en","fr","ar"],"globalName":"nuxt"});
  if({"barBackground":"#fff","barButtonColor":"#fff","barButtonHoverColor":"#01BAC6","barButtonBackground":"#01BAC6","barTextColor":"#000","modalButtonColor":"#fff","modalButtonHoverColor":"#fff","modalTextColor":"#000","modalBackground":"#fff","checkboxInactiveBackground":"#eee","checkboxActiveBackground":"#01BAC6","modalButtonBackground":"#01BAC6"} !== false){
    cookies.colors = {
      barTextColor: '#fff',
      modalOverlay: '#000',
      barBackground: '#000',
      barButtonColor: '#000',
      modalTextColor: '#000',
      modalBackground: '#fff',
      modalOverlayOpacity: 0.8,
      modalButtonColor: '#fff',
      modalUnsavedColor: '#fff',
      barButtonHoverColor: '#fff',
      barButtonBackground: '#fff',
      modalButtonHoverColor: '#fff',
      controlButtonIconColor: '#000',
      modalButtonBackground: '#000',
      controlButtonBackground: '#fff',
      barButtonHoverBackground: '#333',
      checkboxActiveBackground: '#000',
      controlButtonIconHoverColor: '#fff',
      checkboxInactiveBackground: '#000',
      modalButtonHoverBackground: '#333',
      checkboxDisabledBackground: '#ddd',
      controlButtonHoverBackground: '#000',
      checkboxActiveCircleBackground: '#fff',
      checkboxInactiveCircleBackground: '#fff',
      checkboxDisabledCircleBackground: '#fff',
    };
    Object.assign(cookies.colors, {"barBackground":"#fff","barButtonColor":"#fff","barButtonHoverColor":"#01BAC6","barButtonBackground":"#01BAC6","barTextColor":"#000","modalButtonColor":"#fff","modalButtonHoverColor":"#fff","modalTextColor":"#000","modalBackground":"#fff","checkboxInactiveBackground":"#eee","checkboxActiveBackground":"#01BAC6","modalButtonBackground":"#01BAC6"});
  }

  let methods = {
    get: (cookie) => {
      if(process.browser){
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        let name = `${cookie}=`;
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
      }
      return '';
    },

    set: ({name, value='', expires='', path='/', domain}) => {
      let domainName = domain ? domain : cookies.domain ? `.${cookies.domain}` : domain;
      if(process.browser){
        document.cookie = `${name}=${value};expires=${expires};path=${path}${domainName !== undefined ? `;domain=${domainName}` : ';'}`;
      } else if(process.server){
        context.res.setHeader('Set-Cookie', [`${name}=${value}; Expires=${expires}; Path=${path}${domainName !== undefined ? `; Domain=${domainName}` : ';'}`]);
      }
    },

    isEnabled: (identifier) => {
      return cookies.enabledList.includes(identifier) || cookies.enabledList.includes(cookies.slugify(identifier))
    },

    setBlockedIframes: (content) =>{
      let type = (typeof(content)).toLowerCase();
      let c = type !== 'string' ? JSON.stringify(content) : content;
      c = c.replace(/&lt;/g, '<');
      c = c.replace(/&gt;/g, '>');
      if(context.app.$cookies.enabled.filter(c =>{return c.name === 'functional'}).length === 0){
        c = c.replace(/<iframe/g, `<div class='cookieControl__BlockedIframe '`);
        c = c.replace(/<\/iframe/g, `<p>${context.app.$cookies.text.blockedIframe !== undefined ? context.app.$cookies.text.blockedIframe : ''} <a href='#' onclick='event.preventDefault(); $${cookies.globalName}.$cookies.modal = true'>${context.app.$cookies.text.here !== undefined ? context.app.$cookies.text.here: ''}</a></p></div`);
      }
      return type !== 'string' ? JSON.parse(c) : c
    },

    slugify: (str) =>{
      str = str.replace(/^\s+|\s+$/g, '');
      str = str.toLowerCase();
      let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
      let to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
      for (let i = 0, l = from.length; i < l ; i++){
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

      return str;
    },

    remove: (name) =>{
      if(process.browser){
        let domain = window.location.hostname;
        cookies.set({name, expires: 'Thu, 01 Jan 1970 00:00:00 GMT', domain });
        for (let j = domain.split('.'); j.length;) {
          let o = j.join('.');
          cookies.set({name, expires: 'Thu, 01 Jan 1970 00:00:00 GMT', domain: `.${o}` });
          j.shift();
        }
      }
    },

    acceptNecessary: () => {
      let expires = new Date();
      expires.setFullYear(expires.getFullYear()+1);
      expires = expires.toUTCString();
      const value = cookies.necessary.map(c => c.identifier || cookies.slugify(getName(c.name)))
      cookies.set({name: 'cookie_control_enabled_cookies', value, expires});
      cookies.set({name: 'cookie_control_consent', value: true, expires});
      cookies.consent = true;
      if(process.client){
        setHead();
        callAcceptedFunctions();
      }
    },

    getName: (name) => {
      return typeof(name) === 'string' ? name : name[Object.keys(name)[0]]
    },

    setConsent: (isInit=false) =>{
      cookies.consent = cookies.get('cookie_control_consent') === 'true' ? true : false;
      cookies.enabled = [];
      cookies.enabledList = [];
      if(cookies.consent === true){
        let enabledFromCookie = cookies.get('cookie_control_enabled_cookies');
        cookies.enabled.push(...cookies.optional.filter(c => {
          let cookieName = typeof(c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
          return enabledFromCookie.includes(c.identifier || cookies.slugify(cookieName))
        }));
        cookies.enabledList = cookies.enabled.length > 0 ? cookies.enabled.map(c => {
          let cookieName = typeof(c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
          return c.identifier || cookies.slugify(cookieName)
        }) : [];
      }

      if(cookies.necessary) cookies.enabled.push(...cookies.necessary.filter(c => {return c.src || c.accepted}))

      if(process.client && !isInit){
        setHead();
        clearCookies();
        callAcceptedFunctions();
      }
    }
  }

  Object.assign(cookies, methods);

  const clearCookies = () =>{
    let disabled = cookies.optional.filter(c => {
      let cookieName = typeof(c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
      return !cookies.enabledList.includes(c.identifier || cookies.slugify(cookieName))
    });
    if(disabled.length > 0){
      disabled.forEach(c => {
        if(c.declined) c.declined();
        if(c.cookies && c.cookies.length > 0){
          c.cookies.forEach(i => {
            cookies.remove(i);
          })
        }
        // if(c.src){
        //   for(let s of [...document.head.querySelectorAll(`script[src="${c.src}"]`)]){
        //     s.parentNode.removeChild(s)
        //   }
        // }
      })
    }
  }

  const setHead = () =>{
    if(cookies.enabled.length > 0){
      let head = document.getElementsByTagName('head')[0];
      cookies.enabled.forEach(c =>{
        if(c.src){
          let script = document.createElement('script');
          script.src = c.src;
          head.appendChild(script);
          script.addEventListener('load', () =>{
            if(c.accepted) c.accepted();
          })
        }
      })
    }
  }

  const callAcceptedFunctions = () =>{
    if(cookies.enabled.length > 0){
      cookies.enabled.forEach(c =>{
        if(c.accepted) c.accepted();
      })
    }
  }

  const capitalize = (s) =>{
    if(typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  cookies.setConsent(true)

  if(process.client){
    let globalName = capitalize(cookies.globalName) || 'Nuxt';
    window[`on${globalName}Ready`](() => {
      cookies.setConsent()
    })
  }

  inject('cookies', cookies);
  if(cookies.blockIframe) Vue.component('CookieIframe', CookieIframe);
  Vue.component('CookieControl', CookieControl);
}